import { motion, useReducedMotion } from 'framer-motion';
import { EASE, fadeUpItem, staggerParent } from '@/animations/variants';
import { Reveal } from '@/components/ui/Reveal';
import { salonInfo } from '@/mocks/salonData';

export default function BookingSection() {
  const reduce = useReducedMotion();

  return (
    <section
      id="booking"
      className="py-20 sm:py-28 lg:py-36 bg-cream"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
        <Reveal variants={staggerParent}>
          <motion.p className="section-label mb-6" variants={fadeUpItem}>RESERVATION</motion.p>

          <motion.h2
            className="font-serif-jp text-deep-brown text-xl sm:text-2xl lg:text-3xl leading-snug mb-4"
            variants={fadeUpItem}
          >
            ご予約・お問い合わせ
          </motion.h2>

          <motion.div className="w-16 h-px bg-earth mx-auto mb-6" variants={fadeUpItem}></motion.div>

          <motion.p
            className="font-sans-jp text-earth/85 text-sm sm:text-base leading-relaxed mb-10 max-[605px]:text-left"
            variants={fadeUpItem}
          >
            お電話またはホットペッパーからご予約を承っております。<br className="hidden sm:block" />
            お気軽にご相談ください。
          </motion.p>

          {/* CTA Buttons */}
          <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-6 mt-10" variants={fadeUpItem}>
            {/* Phone */}
            <motion.a
              href={`tel:${salonInfo.phone1}`}
              className="group flex items-center gap-4 bg-forest text-white whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-forest/80 hover:shadow-lg w-full sm:w-auto justify-center rounded-lg px-6 py-4"
              whileHover={reduce ? undefined : { y: -2 }}
              transition={{ duration: 0.3, ease: EASE }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 border border-white/20 flex-shrink-0">
                <i className="ri-phone-line text-white text-lg"></i>
              </div>
              <div className="text-left">
                <p className="font-sans-jp text-white/70 text-xs">PHONE</p>
                <p className="font-sans-jp font-medium text-sm">お電話でのご予約</p>
                <p className="font-sans-jp text-white/60 text-xs">{salonInfo.phone1}</p>
              </div>
            </motion.a>

            {/* Hotpepper */}
            <motion.a
              href={salonInfo.hotpepperUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group flex items-center gap-4 border border-forest text-forest whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-forest hover:text-white hover:shadow-lg w-full sm:w-auto justify-center rounded-lg px-6 py-4"
              whileHover={reduce ? undefined : { y: -2 }}
              transition={{ duration: 0.3, ease: EASE }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-forest/10 border border-forest/30 group-hover:bg-white/10 group-hover:border-white/20 flex-shrink-0 transition-colors duration-300">
                <i className="ri-computer-line text-forest group-hover:text-white text-lg transition-colors duration-300"></i>
              </div>
              <div className="text-left">
                <p className="font-sans-jp text-forest group-hover:text-white/70 text-xs transition-colors duration-300">HOT PEPPER</p>
                <p className="font-sans-jp font-medium text-sm">ホットペッパー</p>
                <p className="font-sans-jp text-earth group-hover:text-white/80 text-xs transition-colors duration-300">ネットで予約可能</p>
              </div>
            </motion.a>
          </motion.div>

          <motion.p className="font-sans-jp text-earth/80 text-xs mt-8" variants={fadeUpItem}>
            受付時間：11:00〜21:00（不定休）
          </motion.p>
        </Reveal>
      </div>
    </section>
  );
}